import "./App.css";
import React, { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Header from "./components/header/header";
import NavigationDrawer from "./components/navigation/navigationDrawer";
import Footer from "./components/footer/footer";
import "devextreme/dist/css/dx.light.css";

function App() {
  const [isOpened, setIsOpened] = useState(false);
  return (
    <div className="App">
      <BrowserRouter>
        <Header isOpened={isOpened} setIsOpened={setIsOpened} />
        <NavigationDrawer isOpened={isOpened} setIsOpened={setIsOpened} />
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;